import axios from "axios"
import { getToken } from "../helpers/functions";

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL
axios.defaults.headers.common["Authorization"] = getToken()
axios.defaults.headers.common["Content-Type"] = "application/json"
axios.defaults.headers.common['development'] = 'true'

export default axios
